document.addEventListener('alpine:init', () => {
  Alpine.data('gallery', () => ({
    swiper: null,
    swiper2: null,

    init() {
      this.$nextTick(() => this.ready());
    },

    ready() {
      const options2 = {
        slidesPerView: 3,
        // loopedSlides: +this.$el.dataset.slides,
        spaceBetween: 16,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          1024: {
            slidesPerView: 8,
          },
          768: {
            slidesPerView: 6,
          },
          640: {
            slidesPerView: 4,
          },
        },
      };

      this.swiper2 = new Swiper(this.$el.querySelector('.gallery__container2'), options2);

      const options = {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        // loop: true,
        // loopedSlides: +this.$el.dataset.slides,
        navigation: {
          prevEl: '.slider__slider-nav-button--prev',
          nextEl: '.slider__slider-nav-button--next',
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        thumbs: {
          swiper: this.swiper2,
        },
      };

      this.swiper = new Swiper(this.$el.querySelector('.gallery__container'), options);
    },
  }));
});